import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalDepositUpdateManyProps {}

const ModalDepositUpdateMany = ({}: ModalDepositUpdateManyProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateManyDeposits');
  const onClose = () => {
    closeSingleModal('updateManyDeposits');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar depósitos"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Deposit.UpdateMany />
    </Modal>
  );
};

export default ModalDepositUpdateMany;
